import React, { useCallback, useRef } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import ArrowDownIcon from '@wix/da-ds/pkg/Icons/ArrowDown';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import PositionOnlyPopperPopover from '@wix/da-ds/pkg/popper/presets/PositionOnlyPopperPopover';
import DSModal from '@wix/da-ds/pkg/modals/dsPresets/Modal';
import Sticky from '@wix/da-ds/pkg/Sticky';
import FolderDropdownDesktopMenu from '../FolderDropdownDesktop/FolderDropdownDesktopMenu';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import { usePopover } from '../../Popovers/redux/hooks';
import { PopoverType } from '../../Popovers/redux/types';
import cssVars from '@wix/da-ds/src/styles/variables.scss';
import folderDropdownMobileStyles from './FolderDropdownMobile.scss';
const FolderDropdownMobileV3 = ({ id, offsetTop = 0, folders, folderNamePostfixIcon, disabled, currentFolder, setSelectedFolderId, arrowIconSize = IconSize.SMALL, showCurrentFolderTotal, isLoading, hasMore, fetchMore })=>{
    const { t } = useTranslation();
    const rootRef = useRef(null);
    const headerHeight = parseInt(cssVars['site-header-height-mobile']);
    const { popover, pushPopover, removePopover } = usePopover(PopoverType.GALLECTION_FOLDER);
    const selectFolder = useCallback((folderId)=>{
        setSelectedFolderId(folderId);
        removePopover();
    }, [
        removePopover,
        setSelectedFolderId
    ]);
    const togglePopover = ()=>{
        if (popover.isOpen) {
            removePopover();
        } else {
            pushPopover();
        }
    };
    return /*#__PURE__*/ React.createElement(PositionOnlyPopperPopover, {
        popoverContent: /*#__PURE__*/ React.createElement(DSModal, {
            isOpen: true,
            heading: t('gallectionDropdown.title.mobile'),
            showHeaderBorder: true,
            contentClassName: folderDropdownMobileStyles['content'],
            withScrollableContentWrapper: true,
            useFixedMobileHeight: true,
            onRequestClose: togglePopover
        }, /*#__PURE__*/ React.createElement(FolderDropdownDesktopMenu, {
            isOpen: true,
            id: id,
            className: folderDropdownMobileStyles['modal-menu'],
            folders: folders,
            setSelectedFolderId: selectFolder,
            currentFolder: currentFolder,
            hasMore: hasMore,
            fetchMore: fetchMore
        }), isLoading && /*#__PURE__*/ React.createElement(LoadingIndicator, {
            coverMode: true,
            view: "llama"
        })),
        isVisible: popover.isOpen
    }, /*#__PURE__*/ React.createElement("div", {
        className: classnames(folderDropdownMobileStyles['root'], disabled && folderDropdownMobileStyles['disabled']),
        ref: rootRef
    }, /*#__PURE__*/ React.createElement(Sticky, {
        className: 'sticky',
        marginTop: offsetTop + headerHeight
    }, (isStuck)=>/*#__PURE__*/ React.createElement("div", {
            className: classnames(folderDropdownMobileStyles['toggle'], isStuck && folderDropdownMobileStyles['stuck']),
            "aria-hidden": "true",
            onClick: togglePopover
        }, /*#__PURE__*/ React.createElement("div", {
            className: classnames(folderDropdownMobileStyles['title'], folderNamePostfixIcon && folderDropdownMobileStyles['title-with-icon'])
        }, currentFolder && currentFolder.name, showCurrentFolderTotal && currentFolder && /*#__PURE__*/ React.createElement("span", {
            className: folderDropdownMobileStyles['folder-total']
        }, currentFolder === null || currentFolder === void 0 ? void 0 : currentFolder.totalItemCount), folderNamePostfixIcon), /*#__PURE__*/ React.createElement(ArrowDownIcon, {
            className: classnames(folderDropdownMobileStyles['icon-arrow'], popover.isOpen && folderDropdownMobileStyles['is-open']),
            size: arrowIconSize
        })))));
};
FolderDropdownMobileV3.displayName = 'FolderDropdownMobileV3';
export default FolderDropdownMobileV3;
